import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function StopIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="6" y="6" width="12" height="12" fill={color} />
    </SVGWrapper>
  );
}

export default StopIcon;
